import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./reducers/authReducer"
import Alert from "./reducers/alertReducer"
import Shared from "./reducers/sharedReducer"
import Roles from "./reducers/rolesReducer"
import Customers from "./reducers/customersReducer"
import Users from "./reducers/usersReducer"
import Branchs from "./reducers/branchsReducer"
import Banners from "./reducers/bannersReducer"
import OfferBanners from "./reducers/offerBannersReducer"
import Categories from "./reducers/categoriesReducer"
import Items from "./reducers/itemsReducer"
import ItemGroups from "./reducers/itemGroupsReducer"
import ModifierGroups from "./reducers/modifierGroupReducer"
import Modifiers from "./reducers/modiferReducer"
import Countries from "./reducers/countriesReducer"
import Region from "./reducers/regionReducer"
import City from "./reducers/cityReducer"
import Allergens from "./reducers/allergensReducer"
import Ingredients from "./reducers/ingredientsReducer"
import ItemTags from "./reducers/itemTagsReducer"
import Common from "./reducers/commonReducer"
import Orders from "./reducers/orderReducer"
import Tax from "./reducers/taxReducer"
import Dashboard from "./reducers/dashboardReducer"
import APILogs from "./reducers/apiLogsReducer"
import Ratings from "./reducers/ratingReducer"
import Menus from "./reducers/menusReducer"
import Brands from "./reducers/brandsReducer"
import Promotions from "./reducers/promotionsReducer"
import GlobalSettings from "./reducers/globalSettingReducer"
import PushNotifications from "./reducers/pushNotificationReducer"
import CustomerSupport from "./reducers/customerSupportReducer"
import Reports from "./reducers/reportsReducer"
import Faqs from "./reducers/faqReducer"
import Bookings from "./reducers/bookingsReducer"
import POS from "./reducers/posReducer"
import Vehicles from "./reducers/vehicleReducer"
import GiftCard from "./reducers/giftCardReducer"
import GiftCardCategories from "./reducers/giftCardCategoriesReducer"
import Templates from "./reducers/templatesReducer"
import StaticMaintenance from "./reducers/staticMaintenanceReducer"
import MenuSetup from "./reducers/menuSetupReducer"
import MenuFilterReducer from "./menuFilter/reducer"
import Zone from "./reducers/zoneReducer"

// Multi-tenancy slices
import Tenant from "./slices/tenantSlice"
import Permissions from "./slices/permissionsSlice"

// Phase 2 slices
import Auth from "./slices/authSlice"
import RolesSlice from "./slices/roleSlice"
import UserSlice from "./slices/userSlice"
import DeliveryPartner from "./slices/deliveryPartnerSlice"

// Subscription / Billing
import Subscription from "./reducers/subscriptionReducer"

// Superadmin
import SuperAdmin from "./reducers/superAdminReducer"

// Tenant Integrations
import TenantIntegration from "./reducers/tenantIntegrationReducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Alert,
  Shared,
  Login,
  Roles,
  Customers,
  Users,
  Banners,
  OfferBanners,
  Menus,
  Brands,
  Branchs,
  Categories,
  Items,
  ItemGroups,
  ModifierGroups,
  Modifiers,
  Countries,
  Region,
  City,
  Allergens,
  Ingredients,
  ItemTags,
  Common,
  Orders,
  Tax,
  Dashboard,
  APILogs,
  Ratings,
  Promotions,
  GlobalSettings,
  PushNotifications,
  CustomerSupport,
  Reports,
  Faqs,
  Bookings,
  POS,
  Vehicles,
  GiftCard,
  GiftCardCategories,
  Templates,
  StaticMaintenance,
  MenuSetup,
  MenuFilterReducer,
  Zone,
  // Multi-tenancy
  Tenant,
  Permissions,
  // Phase 2
  Auth,
  RolesSlice,
  UserSlice,
  DeliveryPartner,
  // Subscription / Billing
  Subscription,
  // Superadmin
  SuperAdmin,
  // Tenant Integrations
  TenantIntegration,
})

export default rootReducer
